import React from "react";
import { connect } from "react-redux";
import classes from "./detail.module.css";
import { ReactComponent as Spinner } from "../../../../assets/spinner.svg";
import { openModal } from "../../../modals/modalActions";
import format from "date-fns/format";

import { updatePettyCash } from "../../pettyCashActions";

const cancelled = (props) => {
  let { transaction, profile, auth, loading, openModal } = props;

  return (
    <table className={classes.FuneralSchemeTable}>
      <thead>
        <tr>
          <th className={"hide-s"} scope="col">
            Amount
          </th>

          <th className={"hide-s"} scope="col">
            Status
          </th>
          <th className={"hide-s"} scope="col">
            Actioned By
          </th>
          <th className={"hide-s"} scope="col">
            Date Actioned{" "}
          </th>
          <th className={"hide-s"} scope="col">
            Reason for Cancellation{" "}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr className={classes.MemberRow}>
          <td>{transaction.amount}</td>
          <td>{transaction.status}</td>
          <td>{transaction.cancelledBy}</td>
          <td>
            {format(transaction.dateCreated.toDate(), "YYYY-MM-DD HH:mm:ss")}
          </td>
          <td>{transaction.cancellationNote}</td>
        </tr>
      </tbody>
    </table>
  );
};

const mapStateToProps = (state) => ({
  loading: state.async.loading,
  auth: state.firebase.auth,
  profile: state.firebase.profile,
});

// const actions = {
//   redeemWinningPurchase,
// };

const actions = {
  updatePettyCash,
  openModal,
};

// export default connect(mapStateToProps, actions)(detail);
export default connect(mapStateToProps, actions)(cancelled);
